// extracted by mini-css-extract-plugin
module.exports = {"component":"story-card-component_component__PZ18p"};